import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserCog } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Sticky bar shown for the whole session while an admin is signed in "as" a user.
export default function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!user?.impersonated_by) return null;

  const handleExit = async () => {
    await stopImpersonation();
    navigate("/admin");
  };

  return (
    <div
      data-testid="impersonation-banner"
      role="status"
      className="sticky top-0 z-[100] flex items-center justify-center gap-3 bg-[#E05236] px-4 py-2 text-white text-xs font-semibold"
    >
      <UserCog className="w-4 h-4 shrink-0" strokeWidth={2} />
      <span className="truncate">
        {t("impersonation.banner", { name: user.name, email: user.email })}
      </span>
      <button
        data-testid="impersonation-exit-btn"
        onClick={handleExit}
        className="shrink-0 rounded-sm border border-white px-2.5 py-1 uppercase tracking-[0.15em] text-[10px] hover:bg-white hover:text-[#E05236] transition-colors"
      >
        {t("impersonation.exit")}
      </button>
    </div>
  );
}
